/** Design System types */
import {
  ResponsiveValue,
  Spacing,
  BodyTypographyScale,
  ResponsiveBodyTypographyScale,
  ResponsiveHeadingTypographyScale,
  HeadingTypographyScale,
} from '@awazevr/design-system.utils.react'

export declare type FlexibleResponsiveValue = [
  Array<number>,
  Array<number>,
  Array<number>,
]

/** Auth MFE Constants */

export const ELEMENT_GROUP_SPACING: Spacing = 24

export const MAIN_HEADING_SIZES:
  | HeadingTypographyScale
  | ResponsiveHeadingTypographyScale = [200, 200, 200]

export const TEXT_SIZES: BodyTypographyScale | ResponsiveBodyTypographyScale = [
  300, 300, 300,
]

export const BANNER_TEXT_SIZES:
  | BodyTypographyScale
  | ResponsiveBodyTypographyScale = [200, 200, 200]

export const PADDING_TOP_MID: FlexibleResponsiveValue | ResponsiveValue = [
  [24, 0, 0, 0],
  [24, 0, 0, 0],
  [24, 0, 0, 0],
]

export const LOCAL_STORAGE_RETURN_URL_KEY = 'awaze-return-url'
